import { all, takeLatest } from "redux-saga/effects";
import { AuthenticationApi as authApi } from "Services/ApiServices";
import { AuthenticationTypes } from "Redux/AuthenticationRedux";
import {
    authenticateEmailSaga,
    authenticationCheckSaga,
    getUserDetailsSaga,
    login,
    passwordResetSaga,
    refreshToken,
    register,
    resetLinkSaga,
    socialAuthLoginSaga,
    updateUserDetailsSaga
  } from "./workers";

/* ------------- API ------------- */

// We create our API
const api = authApi.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* authRoot() {
  yield all([
    takeLatest(
        AuthenticationTypes.AUTHENTICATION_CHECK_REQUEST,
        authenticationCheckSaga,
        api
      ),
      takeLatest(AuthenticationTypes.LOGIN_REQUEST, login, api),
      takeLatest(AuthenticationTypes.REFRESH_TOKEN_REQUEST, refreshToken, api),
      takeLatest(AuthenticationTypes.REGISTER_REQUEST, register, api),
      // takeLatest(
      //   AuthenticationTypes.ADDITIONAL_REGISTRATION_REQUEST,
      //   additionalRegistration,
      //   api
      // ),
      // takeLatest(
      //   AuthenticationTypes.CHECK_PROFILE_COMPLETE_SUCCESS,
      //   checkProfileCompleteSaga,
      //   api
      // ),
      takeLatest(AuthenticationTypes.RESET_LINK_REQUEST, resetLinkSaga, api),
      takeLatest(
        AuthenticationTypes.PASSWORD_RESET_REQUEST,
        passwordResetSaga,
        api
      ),
      takeLatest(
        AuthenticationTypes.AUTHENTICATE_EMAIL_REQUEST,
        authenticateEmailSaga,
        api
      ),
  
      takeLatest(
        AuthenticationTypes.SOCIAL_AUTH_LOGIN_REQUEST,
        socialAuthLoginSaga,
        api
      ),
  
      takeLatest(
        AuthenticationTypes.GET_USER_DETAILS_REQUEST,
        getUserDetailsSaga,
        api
      ),
  
      takeLatest(
        AuthenticationTypes.UPDATE_USER_DETAILS_REQUEST,
        updateUserDetailsSaga,
        api
      ),
  ]);
}

    
    
  